import { SolarLeaderboardSiteSource } from '@black-bear-energy/black-bear-energy-common'
import { DromoSiteRecord, SiteAction, SiteUploadRecord } from 'common/types'
import { siteActionToSiteActionAPIResponse } from '../DromoUploader/siteActionToSiteActionAPIResponse'

export function getSiteUploadRecordList(
  data: DromoSiteRecord[],
  source: keyof typeof SolarLeaderboardSiteSource,
  reitId?: number,
  sourceOther?: string
): SiteUploadRecord[] {
  // don't upload ignored records
  const filteredSites = data.filter(
    (dataRow) => dataRow.siteAction !== SiteAction.Ignore
  )

  const sites = filteredSites.map((dataRow) => {
    const {
      existingRecordId,
      rowId,
      isGeocodeValid,
      siteAction,
      ...siteRecord
    } = dataRow

    for (const key of Object.keys(siteRecord)) {
      const siteValue = siteRecord[key]
      if (siteValue === '' || siteValue === undefined) {
        // change any empty strings/undefined values to null
        siteRecord[key] = null
      }
    }

    siteRecord.reitId = reitId
    siteRecord.source = source
    siteRecord.sourceOther = sourceOther
    // We need `id` to be undefined so the db will generate an auto-incremented id for new records
    siteRecord.id = existingRecordId
      ? parseInt(String(existingRecordId))
      : undefined // empty string for existingRecordId

    if (siteAction === SiteAction.New) {
      siteRecord.id = undefined // explicit new record
    }
    siteRecord.siteAction = siteActionToSiteActionAPIResponse(siteAction)

    return siteRecord as SiteUploadRecord
  })

  return sites
}
